import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Rule } from 'src/app/models/centrex/rule';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';

@Injectable({
    providedIn: 'root',
})
export class RuleService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();
    }
    getGlobalRules(): Observable<Rule[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Rule[]>(`${this.baseUrl}/api/extensions/rules`, httpOptions);
    }

    getGlobalRule(ruleId: string): Observable<Rule> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Rule>(`${this.baseUrl}/api/extensions/rules/${ruleId}`, httpOptions);
    }

    getExtensionRule(extensionId: string, ruleId: string): Observable<Rule> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Rule>(`${this.baseUrl}/api/extensions/${extensionId}/rules/${ruleId}`, httpOptions);
    }

    getExtensionRules(extensionId: string): Observable<Rule[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Rule[]>(`${this.baseUrl}/api/extensions/${extensionId}/rules`, httpOptions);
    }

    addGlobalRule(rule: Rule, globalNotification = true): Observable<Rule> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('global-notification', String(globalNotification))
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.post<Rule>(`${this.baseUrl}/api/extensions/rules`, rule, httpOptions);
    }

    addExtensionRule(rule: Rule, globalNotification = true): Observable<Rule> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('global-notification', String(globalNotification))
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.post<Rule>(`${this.baseUrl}/api/extensions/${rule.extensionId}/rules`, rule, httpOptions);
    }

    updateGlobalRule(rule: Rule): Observable<Rule> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.patch<Rule>(`${this.baseUrl}/api/extensions/rules/${rule.id}`, rule, httpOptions);
    }

    updateExtensionRule(rule: Rule): Observable<Rule> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.patch<Rule>(`${this.baseUrl}/api/extensions/${rule.extensionId}/rules/${rule.id}`, rule, httpOptions);
    }

    deleteGlobalRule(ruleId: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.delete<Rule>(`${this.baseUrl}/api/extensions/rules/${ruleId}`, httpOptions);
    }

    deleteExtensionRule(extensionId: string, ruleId: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.delete<Rule>(`${this.baseUrl}/api/extensions/${extensionId}/rules/${ruleId}`, httpOptions);
    }
}
